import React from "react";
import Navbar from '../../components/modules/Navbar'
import './faqStyles.css'
import {Data} from './dataFaq'
import { useState } from "react";
import FlecheRightFaq from "../../components/function/flecheRightFaq";
import FlecheDownFaq from "../../components/function/flecheDownFaq";
import Footer from "../../components/modules/Footer";
import { useTranslation} from "react-i18next";

const Faq = () => {
    const { t } = useTranslation('common');
    const [openCard,setOpenCard] = useState(false);

    const toggle = index =>{
        if (openCard === index){
            return setOpenCard(null)
        }

        setOpenCard(index)
    }
    

    return (
        <div>
            <Navbar scroll='true' color='rgba(23, 15, 73, 1)'/>
            <div className="faq">
                <h1> F.A.Q</h1>
                <div className="faq-container">
                    {Data.map((item,index) =>{
                       
                        return (
                            <div className={openCard === index ? 'faq-card display' : 'faq-card'}>
                                <div className="faq-content" onClick={() => toggle(index)} key={index}>
                                    <h2> {t(`FAQ.question${item.question}`)}</h2>

                                                <div>
                                                   {openCard === index ? 
                                                            <FlecheDownFaq />
                                                                            : 
                                                      <FlecheRightFaq />
                                                                            }
                                                     
                                                   
                                                </div>  
                                 

                                 </div>
                                 <div className={openCard === index ? 'faq-inner active-text':'faq-inner'}>
                                    <p> {t(`FAQ.answer${item.question}`)}</p>
                                    {index === 2 ?
                                    <a href="https://toss-register.bds-cs.fr"> S'inscrire</a>:
                                    <>
                                    </>

                                    }
                                      {index === 1 ?
                                    <a style={{width:250}}href="mailto:toss@cs-sports.fr"> toss@cs-sports.fr</a>:
                                    <>
                                    </>

                                    }
                                </div>
                                
                            </div> 
                        )
                       
                    })
                }
                    
                </div>

            </div>
            <Footer color='rgba(23, 15, 73, 1)' color2='rgba(111, 108, 144, 1)'/>
        </div>
    )

}

export default Faq